export const resourceSubCategoryAddComponent = {

    template: `
        <resources-subcategory-main
        on-cancel='$ctrl.onCancel(isUpdated)'
        on-submit='$ctrl.onSubmit(details)'
        title="add new resource"
        disable-buttons='$ctrl.disableButtons'>
        </resources-subcategory-main>
        `,

    controller: class ResourceSubCategoryAddComponent {
        constructor($state, resourcesService, $stateParams, toastr, ModalService) {
            'ngInject';

            this.$state = $state;
            this.resourcesService = resourcesService;
            this.toastr = toastr;
            this.modalService = ModalService;
            this.$stateParams = $stateParams;
        }
        $onInit() {
            this.slug = this.$stateParams.slug
        }

        onSubmit(categoryDetails) {
            this.disableButtons = true;
            let details = {
                name: categoryDetails.name,
                url: categoryDetails.link
            }
            this.resourcesService.addResourceCategory(details, this.slug)
                .then((details) => {
                    this.toastr.success('Resources added successfully');
                    this.$state.go('resourceCategory', {
                        slug: this.slug,
                    });
                }).catch((err) => {
                    this.disableButtons = false;
                    this.toastr.error(err);
                });
        }

        onCancel(isUpdated) {
            if (isUpdated) {
                this.modalService.open({
                    details: {
                        bodyMessage: 'Changes done will be reverted. Continue?'
                    },
                    buttons: [{
                        name: 'cancel'
                    }, {
                        name: 'ok',
                        isPrimary: true,
                        action: () => {
                            this.$state.go('resourceCategory', {
                                slug: this.slug,
                            });
                        }
                    }]
                });
            } else {
                this.$state.go('resourceCategory', {
                    slug: this.slug,
                });
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/components/resources/resource-subcategory-add/resource-subcategory-add.component.js